import api from '../api';

export const fetchMenuOptions = async (cargo_id) => {
  if (cargo_id === undefined || cargo_id === null) {
    console.error('Erro ao carregar itens do menu! Permissão não encontrada.');
    return false;
  }

  try {
    const response = await api.get('/menu-items?cargo_id=' + cargo_id);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar itens do menu!', error);
  }
};
